import * as Sentry from '@sentry/react'
import PropTypes from 'prop-types'
import React from 'react'

import { logAppError } from 'Helpers/logger'

const ErrorBoundary = ({ children }) => {
  const handleError = (error, errorInfo) => {
    console.error('### error', error, errorInfo)
    logAppError({
      appError: error,
      appErrorStack: errorInfo,
    })
  }

  return (
    <Sentry.ErrorBoundary onError={handleError}>
      {children}
    </Sentry.ErrorBoundary>
  )
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
}

export default ErrorBoundary
